import { NgModule } from '@angular/core';
import { ChronometerPipe } from './chronometer-pipe/chronometer.pipe';

@NgModule({
  declarations: [ChronometerPipe],
  providers: [ChronometerPipe],
  exports: [ChronometerPipe],
})
export class ChronometerModule {}
